module.exports = __webpack_public_path__ + "_/assets/images/icons/icon-settings-9623bd8c982887ef2e27b9c069451ead.svg";